module.exports = "<div class=\"nav-link btn-group\" *ngIf=\"authService.isAuthorized\"><button class=\"btn btn-sm btn-primary\" type=\"button\" *ngFor=\"let i of indicators\" title=\"{{i.modified | asDateTime}}\" [routerLink]=\"i.indicatorTypeHref\">{{i.indicatorTypeDisplay}}<span class=\"badge\" [ngClass]=\"i.indicatorTypeStyle\">{{i.count}}</span></button></div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/kpi/indicator.component.pug
// module id = ./src/app/modules/kpi/indicator.component.pug
// module chunks = main